/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import { Grid } from '@mui/material';
import { RancherCardNew } from './RancherCardNew';


export const RanchdbStats = ({ stat }) => {

  return (
    <Grid
      container
      spacing={2}
      sx={{ marginBottom: '2rem' }}
    >
      <Grid item xs={3}>
        <RancherCardNew label="Onboarded Ranchers" count={stat?.totalProducers || 0} />
      </Grid>
      <Grid item xs={3}>
        <RancherCardNew label="Onboarded Ranches" count={stat?.totalFields || 0} />
      </Grid>
      <Grid item xs={3}>
        <RancherCardNew
          label="Onboarded Area (acres)"
          count={stat.totalArea ? Number.parseFloat(stat?.totalArea.acre).toFixed(0) : 0}
        />
      </Grid>
      <Grid item xs={3}>
        <RancherCardNew
          label="Onboarded Area (hectares)"
          count={stat.totalArea ? (Number.parseFloat(stat?.totalArea?.hectare)).toFixed(0) : 0}
        />
      </Grid>
    </Grid>
  );
};


